import axios from 'axios'

const chatbotApi = axios.create({
  baseURL: process.env.REACT_APP_SERVER_HOST,
})

export function setChatbotToken (token) {
  if (token) {
    chatbotApi.defaults.headers.common.Authorization = `Bearer ${token}`
  } else {
    delete chatbotApi.defaults.headers.common.Authorization
  }
}

export default chatbotApi
